import { produce } from "immer";
import { IInternetConnectionActionsTypes } from "./internetConnectionActions";
import {
    INTERNET_CONNECTION_CHANGE,
    INTERNET_CONNECTION_INIT_SUCCESS,
    INTERNET_CONNECTION_MEASURE_SPEED_SUCCESS
} from "./internetConnectionConstants";

export interface IInternetConnectionState {
    online: boolean,
    isInited: boolean,
    speedKbps: number,
}

const initialState: IInternetConnectionState = {
    online: navigator.onLine,
    isInited: false,
    speedKbps: 0,
}

const internetConnectionReducer = (state: IInternetConnectionState = initialState, action: IInternetConnectionActionsTypes) =>
    produce(state, (draft: IInternetConnectionState) => {
        switch (action.type) {
            case INTERNET_CONNECTION_INIT_SUCCESS:
                draft.isInited = true;
                break;
            case INTERNET_CONNECTION_MEASURE_SPEED_SUCCESS:
                draft.speedKbps = action.payload;
                break;
            case INTERNET_CONNECTION_CHANGE:
                draft.online = action.payload;
                break;    
            default:
                return state;
        }
    });

export default internetConnectionReducer
